import styled from '@emotion/styled'

const RemoveButtonContainer = styled.div`
	justify-content: center;
	align-items: center;

	.remove-button {
		font-size: 1rem;
		border-radius: 5px;

		svg {
			margin-right: 10px;
			margin-top: -3px;
		}
	}
`

export { RemoveButtonContainer }
